/**
 * Phase 3 — registers public/service-worker.js and wires up Background
 * Sync so the outbox can be flushed even when no tab is open, on browsers
 * that support the SyncManager API (Chromium/Android — the target
 * platform for this app; Safari/iOS simply skips this and relies on the
 * foreground polling fallback already in syncManager.js).
 */

const isLocalhost = Boolean(
  typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"),
)

export function registerServiceWorker(onBackgroundSyncMessage) {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return

  window.addEventListener("load", () => {
    const swUrl = "/service-worker.js"

    navigator.serviceWorker
      .register(swUrl, { updateViaCache: "none" })
      .then((registration) => {
        console.log("[v0] Service worker registered:", registration.scope)

        if ("sync" in registration) {
          registration.sync.register("encoaudit-outbox-sync").catch((error) => {
            console.log("[v0] Background Sync registration failed:", error?.message)
          })
        }
      })
      .catch((error) => {
        console.log("[v0] Service worker registration failed:", error?.message)
      })

    navigator.serviceWorker.addEventListener("message", (event) => {
      if (event.data?.type === "ENCOAUDIT_BACKGROUND_SYNC" && onBackgroundSyncMessage) {
        onBackgroundSyncMessage()
      }
    })
  })
}

export function unregisterServiceWorker() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => console.log("[v0] Service worker unregister failed:", error?.message))
  }
}

export { isLocalhost }
